// extracted by css-extract-rspack-plugin
export default {"root":"root-dukD6S","list":"list-q4ZMe_","with-shift":"with-shift-JJgVIR","withShift":"with-shift-JJgVIR"};